import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ICONS from "../../../assets/Icons";
import { beneBankLookUp } from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";

import { ownerListViewAllAcc } from "../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import { beneLookUp } from "../../../redux/features/verifyPAN/verifyPAN";
import TEXT from "../../../utils/globalText";
import SVGComponent from "../../_utils/SVGComponent";
import ConfidentialCard from "../../_utils/TransactionCommonComponents/ConfidentialCard";
import SourceDestinationAccountDetail from "../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import CommonLayout from "../../_utils/CommonLayout";

const InternalTxnSelectAccount = (props) => {
  const dispatch = useDispatch();

  const [remPan, setRemPan] = useState("");
  const [remIFSC, setRemIFSC] = useState("");
  const [remAccount, setRemAccount] = useState("");
  const [activeType, setActiveType] = useState("pan");
  const [havePANAssociate, setHavePANAssociate] = useState(0);
  const [haveBankAssociate, setHaveBankAssociate] = useState(0);

  const { beneLookData } = useSelector((state) => state.verify);
  const bankData = useSelector(
    (state) => state.beneAllVerification.beneLookData,
  );
  const { beneTransCategories } = useSelector(
    (state) => state.beneAllVerification,
  );

  const shouldShowAssociatedAccounts =
    (haveBankAssociate > GlobalConfiguration?.lengthCheckOne ||
      havePANAssociate > GlobalConfiguration?.lengthCheckOne) &&
    props?.accountNumber &&
    props?.IFSC;

  const handleCloseModal = () => {
    props.setIsModalOpen(false);
  };

  const handleAccountSelection = async (
    accountName,
    accountNumber,
    ifsc,
    bankLogo,
    category,
    panNo,
    beneAccountId,
    labels,
  ) => {
    props?.setRefactorDestinationAccDetail(false);
    const categoriesArray = category?.split(",");
    props?.setCategory(categoriesArray);
    props?.setAccountName(accountName);
    props?.setAccountNumber(accountNumber);
    props?.setIFSC(ifsc);
    props?.setBankLogo(bankLogo);
    props?.setBeneAccountId(beneAccountId);
    props?.setPanNumber(panNo);
    props?.setSelectedCategory(null);

    dispatch(beneLookUp({ pan_number: panNo }));
    dispatch(
      beneBankLookUp({
        ifsc: ifsc,
        bank_account_no: accountNumber,
      }),
    );

    let data1 = await dispatch(
      ownerListViewAllAcc({
        bank_account_no: accountNumber,
        pan: panNo,
        ifsc: ifsc,
      }),
    );

    props.setTxnPayLoad({
      ...props.txnPayLoad,
      bankAccountName: accountName,
      beneAccountId: beneAccountId,
      bankAccountIFSC: ifsc,
      bankAccountNo: accountNumber,
      bankLogo: bankLogo,
      pan: panNo,
      labels: labels,
      isDestinationOwnerActive:
        data1?.payload?.owner_accounts[0]?.connected_banking === "Y"
          ? true
          : false,
      destinationAccountBalance:
        data1?.payload?.owner_accounts[0]?.owner_account_balance,
      destinationAcountOwnerId: data1?.payload?.owner_accounts[0]?.id,
      destinationAcountOwnerLastUpdated:
        data1?.payload?.owner_accounts[0]
          ?.owner_account_balance_last_fetched_at_in_words,
      selectedCategory: beneTransCategories?.categories?.filter((fil) => {
        return fil.name === "Internal";
      })[0],
      mergeCategory: beneTransCategories?.categories?.filter((fil) => {
        return fil.name === "Internal";
      })[0]?.configuration?.data,
    });
    handleCloseModal();
  };

  const handleOwnerSelection = (name, acc, ifsc, logo, ownerId) => {
    props?.setTxnPayLoad((prev) => ({
      ...prev,
      ownerId,
      ownerBankAccountName: name,
      ownerBankAccountNo: acc,
      ownerBankIFSC: ifsc,
      ownerBankLogo: logo,
    }));
  };

  useEffect(() => {
    if (props?.activeStep === 0 && props?.selectedCategory === null) {
      props?.setNextButtonEnabled(true);
    } else if (props?.activeStep === 0 && props?.selectedCategory !== null) {
      props?.setNextButtonEnabled(false);
    }
  }, [props?.activeStep]);

  useEffect(() => {
    setHaveBankAssociate(bankData?.total_count || 0);
    setHavePANAssociate(beneLookData?.total_count || 0);
  }, [beneLookData, bankData, dispatch]);
  return (
    <div
      className={`w-width-full Qlg:px-padding-base px-padding-md py-padding-md max-w-tab-width-normal mx-auto`}
    >
      <CommonLayout>
        <SourceDestinationAccountDetail
          type="source"
          modalOpen={props?.openOwner}
          setModalOpen={props?.setOpenOwner}
          txnPayLoad={props?.txnPayLoad}
          setTxnPayLoad={props?.setTxnPayLoad}
          handleOnAccountSelection={handleOwnerSelection}
        />

        <div
          className={`lg:flex-1 lg:max-w-[var(--create-box-width)] w-width-full lg:w-auto ${
            !props?.txnPayLoad?.ownerBankAccountNo
              ? "opacity-light-opacity pointer-events-none"
              : "opacity-base-opacity"
          } `}
        >
          <SourceDestinationAccountDetail
            type="destination"
            flow="internal"
            modalOpen={props?.isModalOpen}
            setModalOpen={props?.setIsModalOpen}
            txnPayLoad={props.txnPayLoad}
            setTxnPayLoad={props.setTxnPayLoad}
            shouldShowAssociatedAccounts={shouldShowAssociatedAccounts}
            handleOnAccountSelection={handleAccountSelection}
            activeType={activeType}
            setActiveType={setActiveType}
            setRemPan={setRemPan}
            setRemAccount={setRemAccount}
            setRemIFSC={setRemIFSC}
            remIFSC={remIFSC}
            remAccount={remAccount}
            remPan={remPan}
          />
        </div>

        <ConfidentialCard
          icon={ICONS.CONFIDENTIAL_TRANSACTION}
          title={TEXT?.CREATE_AS_CONFIDENTIAL}
          note={TEXT?.CONFIDENTIAL_TRANSACTION_NOTE}
          toggleState={props?.isConfidential}
          onToggle={() => props?.setIsConfidential(!props?.isConfidential)}
        />
      </CommonLayout>
    </div>
  );
};

export default InternalTxnSelectAccount;
